export default __webpack_public_path__ + "static/media/car_icon.d4401321.svg";